import React from 'react';

const WarningIcon = ({ 
  color = '#002861',
  className = '',
  style = {}
}: { 
  color: string,
  className?: string,
  style?: React.CSSProperties
}) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 20 17"
      fill="none"
      className={className}
      style={style}
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6766 0.390349C10.2455 0.19866 9.75338 0.19866 9.32228 0.390349C8.98934 0.538392 8.77306 0.799157 8.62256 1.01164C8.47459 1.22055 8.31617 1.49423 8.14194 1.79523L1.25265 13.6949C1.07772 13.997 0.91876 14.2715 0.810976 14.5045C0.701434 14.7413 0.582597 15.0596 0.620472 15.4229C0.669481 15.8929 0.915765 16.3201 1.29803 16.598C1.59344 16.8128 1.92844 16.8695 2.18824 16.8933C2.44386 16.9167 2.76107 16.9167 3.11015 16.9167H16.8887C17.2378 16.9167 17.555 16.9167 17.8107 16.8933C18.0705 16.8695 18.4055 16.8128 18.7009 16.598C19.0831 16.3201 19.3294 15.8929 19.3784 15.4229C19.4163 15.0596 19.2975 14.7413 19.1879 14.5045C19.0801 14.2715 18.9212 13.997 18.7463 13.695L11.8569 1.7952C11.6827 1.49422 11.5243 1.22053 11.3763 1.01164C11.2258 0.799156 11.0096 0.538392 10.6766 0.390349ZM10.8328 6.50004C10.8328 6.0398 10.4597 5.66671 9.99947 5.66671C9.53923 5.66671 9.16614 6.0398 9.16614 6.50004V9.83337C9.16614 10.2936 9.53923 10.6667 9.99947 10.6667C10.4597 10.6667 10.8328 10.2936 10.8328 9.83337V6.50004ZM9.99947 12.3334C9.53923 12.3334 9.16614 12.7065 9.16614 13.1667C9.16614 13.6269 9.53923 14 9.99947 14H10.0078C10.468 14 10.8411 13.6269 10.8411 13.1667C10.8411 12.7065 10.468 12.3334 10.0078 12.3334H9.99947Z"
        fill={color}
      />
    </svg>
  );
};

export default WarningIcon;
